
// Get all icon types.
export function getIconTypes( icons ) {
	const iconTypes = [];

	icons.forEach( ( type ) => {
		const iconType = type?.type;
		const typeTitle = type?.title ?? type?.type;
		const isDefault = type?.isDefault ?? false;

		if (iconType != null && 
			( 
			  (Array.isArray(iconType) && iconType.length > 0) || 
			  (typeof iconType === 'string' && iconType.trim().length > 0) || 
			  (typeof iconType === 'object' && Object.keys(iconType).length > 0)
			)
		  ) {
			iconTypes.push( {
				type: iconType,
				title: typeTitle,
				isDefault,
			} );
		}
	} );

	return iconTypes;
}



export function flattenIconsArray(icons) {
    let allIcons = [];

    if (!Array.isArray(icons)) {
        console.warn("Expected icons to be an array, got:", icons);
        return allIcons;
    }

    icons.forEach((type) => {
        const iconType = type?.type;
        const iconsOfType = type?.icons;

        // Add a null/undefined check before using isEmpty
        if (iconsOfType && 
			( 
			  (Array.isArray(iconsOfType) && iconsOfType.length > 0) || 
			  (typeof iconsOfType === 'string' && iconsOfType.trim().length > 0) || 
			  (typeof iconsOfType === 'object' && Object.keys(iconsOfType).length > 0)
			)
		  ) {
            // Append the type to the icon name and add the type parameter.
            iconsOfType.forEach((icon) => {
                // Avoid recursion error
                if (!icon.name.includes(iconType + '-')) {
                    icon.name = iconType + '-' + icon.name;
                }
                icon.type = iconType;
            });

            // Sort the icons alphabetically
            iconsOfType.sort((a, b) => a.name.localeCompare(b.name));

            allIcons = allIcons.concat(iconsOfType);
        }
    });

    return allIcons;
}


// Simplify the categories into a single array.
export function simplifyCategories( categories ) {
	const simplifiedCategories = [];

	categories.forEach( ( category ) => {
		if ( category?.name ) {
			simplifiedCategories.push( category.name );
		}
	} );

	// Make sure the array is alphabetized with any 'all_' categories first.
	simplifiedCategories.sort( ( a, b ) => {
		// Prioritize any string starting with 'all__'.
		if ( a.startsWith( 'all__' ) ) return -1;
		if ( b.startsWith( 'all__' ) ) return 1;

		return a.localeCompare( b ); // Otherwise, sort alphabetically.
	} );

	// Return an alphabetized array of categories.
	return simplifiedCategories;
}
